import { render } from "./index.vue?vue&type=template&id=f8a33f68"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=f8a33f68&lang=less"
script.render = render

export default script